import { useParams } from 'react-router-dom';
import {
  ChatWidgetContextProvider,
  MessageList,
  useChatWidgetContext,
} from 'features/nekst-widgets';
import ConversationsSidebar from './ConversationsSidebar';
import FullPageComposer from './FullPageComposer';

function ConversationArea() {
  const { isLoadingConversation } = useChatWidgetContext();

  if (isLoadingConversation) {
    return (
      <div className="flex flex-1 flex-col overflow-hidden min-w-0">
        <div className="flex-1 flex items-center justify-center text-gray-400 text-sm">
          Loading conversation...
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col overflow-hidden min-w-0">
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 flex flex-col overflow-hidden max-w-[900px] mx-auto w-full">
          <MessageList />
        </div>
      </div>
      <div className="max-w-[900px] mx-auto w-full" style={{ padding: '0 16px 16px' }}>
        <FullPageComposer />
        <p className="text-gray-400 text-center" style={{ fontSize: '12px', padding: '4px 0' }}>
          Nekst AI can make mistakes. Consider checking important information.
        </p>
      </div>
    </div>
  );
}

function LlmChatContent() {
  return (
    <div
      className="fixed inset-0 flex bg-white"
      style={{ top: '65px', zIndex: 1 }}
      data-testid="llm-chat-page"
    >
      <div
        className="flex-shrink-0 border-r border-gray-200 bg-gray-50"
        style={{ width: '260px' }}
      >
        <ConversationsSidebar />
      </div>
      <ConversationArea />
    </div>
  );
}

export default function LlmChatPage() {
  const { chatId } = useParams<{ chatId: string }>();

  return (
    <ChatWidgetContextProvider
      conversationId={chatId ? parseInt(chatId, 10) : undefined}
    >
      <LlmChatContent />
    </ChatWidgetContextProvider>
  );
}
